/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

export const FILL = ({
  fixed: 'fixed',
  intrinsic: 'intrinsic'
} as const);
export const STATE_CHANGE_TYPE = ({
  change: 'change'
} as const);